export default {
  CLOSE_MENU: 'סגור תפריט',
} as const;
